import React from 'react';
import Star from './Star';
import PropTypes from 'prop-types';

function Ratings({ rating, starWidth, starColor, starEmptyColor, style }) {
  let numStars = 5;
  let buffer = rating;
  const fillValues = [];
  while (numStars-- > 0) {
    if (buffer >= 1) {
      fillValues.push(100);
    } else if (buffer < 1 && buffer > 0) {
      fillValues.push(buffer * 100);
    } else {
      fillValues.push(0);
    }
    buffer--;
  }

  return (
    <div style={{ display: 'flex', ...style }}>
      { fillValues.map((fill, index) => {
        return (
          <Star
            key={ `star-${index}` }
            fill={ fill }
            width={ starWidth }
            color={ starColor }
            emptyColor={ starEmptyColor }
          />
        );
      }) }
    </div>
  );
}

Ratings.propTypes = {
  rating: PropTypes.number.isRequired,
  starWidth: PropTypes.string,
  starColor: PropTypes.string,
  starEmptyColor: PropTypes.string,
  style: PropTypes.object
};

Ratings.defaultValue = {
  rating: 5.0,
  style: {}
};

export default Ratings;
